export default __webpack_public_path__ + "static/media/home-icon-active.f3f7451b.webp";